"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.button = void 0;
const tv_1 = require("../utils/tv");
const Variants = {
  primary: 'primary',
  secondary: 'secondary',
  error: 'error'
};
const Backgrounds = {
  fill: 'fill',
  outline: 'outline',
  ghost: 'ghost'
};
/**
 * Button component styles with variants for different use cases
 */
exports.button = (0, tv_1.tv)({
  base: `
    inline-flex items-center justify-center gap-sm font-primary font-medium
    leading-md tracking-xl
    first-letter:uppercase
    focus:outline-none focus:outline-2 focus:outline-offset-1
    focus:outline-keyboard-focus
  `,
  variants: {
    variant: {
      [Variants.primary]: ``,
      [Variants.secondary]: ``,
      [Variants.error]: ``
    },
    size: {
      small: `px-lg py-sm text-sm`,
      large: `px-xl py-md text-md`
    },
    shape: {
      rounded: `rounded-sm`,
      pill: `rounded-full`
    },
    background: {
      [Backgrounds.fill]: ``,
      [Backgrounds.outline]: `border-md bg-transparent`,
      [Backgrounds.ghost]: `bg-transparent`
    }
  },
  compoundVariants: [{
    variant: Variants.primary,
    background: Backgrounds.fill,
    class: `
        bg-brand text-brand-foreground
        hover:bg-brand-hover
        active:bg-brand-active
        disabled:bg-brand-disabled
      `
  }, {
    variant: Variants.secondary,
    background: Backgrounds.fill,
    class: `
        bg-support text-neutral-foreground
        hover:bg-support-hover
        active:bg-support-active
        disabled:bg-support-disabled
      `
  }, {
    variant: Variants.error,
    background: Backgrounds.fill,
    class: `
        bg-critical text-critical-foreground
        enabled:hover:bg-critical-hover enabled:active:bg-critical-active
        disabled:bg-critical-disabled
      `
  }, {
    variant: Variants.primary,
    background: Backgrounds.outline,
    class: `
        border-brand text-brand
        enabled:hover:bg-brand-soft-hover enabled:active:bg-brand-soft-active
        disabled:border-brand-disabled disabled:text-brand-disabled
      `
  }, {
    variant: Variants.secondary,
    background: Backgrounds.outline,
    class: `
        border-neutral text-neutral
        enabled:hover:bg-support-soft-hover
        enabled:active:bg-support-soft-active
        disabled:border-neutral-disabled disabled:text-neutral-disabled
      `
  }, {
    variant: Variants.error,
    background: Backgrounds.outline,
    class: `
        border-critical text-critical
        enabled:hover:bg-critical-soft-hover
        enabled:active:bg-critical-soft-active
        disabled:border-critical-disabled disabled:text-critical-disabled
      `
  }, {
    variant: Variants.primary,
    background: Backgrounds.ghost,
    class: `
        text-brand
        enabled:hover:bg-brand-soft-hover enabled:active:bg-brand-soft-active
        disabled:text-brand-disabled
      `
  }, {
    variant: Variants.secondary,
    background: Backgrounds.ghost,
    class: `
        text-neutral
        enabled:hover:bg-support-soft-hover
        enabled:active:bg-support-soft-active
        disabled:text-neutral-disabled
      `
  }, {
    variant: Variants.error,
    background: Backgrounds.ghost,
    class: `
        text-critical
        enabled:hover:bg-critical-soft-hover
        enabled:active:bg-critical-soft-active
        disabled:text-critical-disabled
      `
  }],
  defaultVariants: {
    variant: Variants.primary,
    size: 'small',
    shape: 'rounded',
    background: Backgrounds.fill
  }
});
